<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo">
        <i class="fas fa-users-cog icon"></i>
        Encuestas
      </div>

      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link :to="{ name: 'functionary' }">
                <span>
                  <i class="fas fa-home icon"></i>
                  inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{ name: 'questionary' }">
                <span>
                  <i class="fas fa-user-cog icon"></i>
                  Encuestas
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div slot="contenido">
        <ShowQuestionary
          v-if="isComponentModalActive"
          :isComponentModalActive="isComponentModalActive"
          :questionarie_id="questionarie_id"
          :closeBasic="closeBasic"
          :chargeQuestionarieList="chargeQuestionarieList"
        ></ShowQuestionary>
        <article class="message is-info">
          <div class="message-body">
            Para abrir la encuesta, <strong>presionar</strong> el boton que dice
            <strong>Abrir Encuesta</strong>
          </div>
        </article>
        <div class="box">
          <b-table
            type="is-primary"
            :data.sync="listQuestionarie"
            :loading="loading"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :is-fullwidth="true"
            default-sort="stablishment.name"
            aria-next-label="Next page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="id" label="ID">{{
                props.row.questionary.id
              }}</b-table-column>
              <b-table-column field="name" label="Nombre">{{
                props.row.questionary.name
              }}</b-table-column>

              <b-table-column field="description" label="Descripción">{{
                props.row.questionary.description
              }}</b-table-column>
              <b-table-column field="state" label="Estado de Cuestionario">
                <span
                  class="tag is-success"
                  v-if="props.row.questionary.state == 'Abierta'"
                >
                  {{ props.row.questionary.state }}
                </span>
                <span
                  class="tag is-danger"
                  v-if="props.row.questionary.state == 'Cerrada'"
                >
                  {{ props.row.questionary.state }}
                </span>
                <span
                  class="tag is-info"
                  v-if="props.row.questionary.state == 'Creada'"
                >
                  {{ props.row.questionary.state }}
                </span>
              </b-table-column>
              <b-table-column field="date_start" label="Inicio">{{
                props.row.questionary.date_start
              }}</b-table-column>
              <b-table-column field="date_end" label="Fin">{{
                props.row.questionary.date_end
              }}</b-table-column>
              <b-table-column field="state" label="Estado">
                <div
                  v-if="props.row.questionary.users_questionaries.length == 0"
                >
                  Sin Responder
                </div>
                <div v-else>
                  {{ props.row.questionary.users_questionaries[0].state }}
                </div>
              </b-table-column>
              <b-table-column label="Acciones">
                <div
                  v-if="
                    props.row.questionary.users_questionaries.length == 0 &&
                    props.row.questionary.state == 'Abierta'
                  "
                >
                  <b-button
                    type="is-info is-small"
                    @click="openBasic(props.row.questionary.id)"
                    >Abrir Encuesta</b-button
                  >
                </div>
                <div
                  v-else-if="
                    props.row.questionary.users_questionaries.length != 0
                  "
                >
                  Encuesta ya Respondida
                </div>
                <div v-else>Encuesta No Disponible</div>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from "../../../template/PlantillaContenido";
import ShowQuestionary from "../../../components/functionary/showQuestionary";
import { getQuestionarie } from "../../../services/questionarie";

export default {
  components: {
    PlantillaContenido,
    ShowQuestionary,
  },
  data() {
    return {
      questionarie_id: null,
      listQuestionarie: [],
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5,
    };
  },
  mounted: function () {
    this.chargeQuestionarieList();
  },
  methods: {
    async openBasic(id) {
      let loader = this.$buefy.loading.open();
      this.questionarie_id = id;
      await getQuestionarie(this.$http, id).then((response) => {
        loader.close();
        console.log("Tiene Term?", response.term_required);
        if (response.term_required == 1) {
          //  var parser = new DOMParser();
          // var doc = parser.parseFromString(response.term.message, "text/html");
          this.$buefy.dialog.confirm({
            title: response.term.title,
            message: response.term.message,
            cancelText: "No Acepto",
            confirmText: "Acepto",
            type: "is-success",
            onConfirm: () => (this.isComponentModalActive = true),
          });
        } else {
          this.isComponentModalActive = true;
        }
      });
    },
    closeBasic() {
      this.questionarie_id = null;
      this.isComponentModalActive = false;
    },
    chargeQuestionarieList() {
      console.log(
        JSON.parse(window.localStorage.getItem("user")).stablishment_id
      );
      this.loading = true;
      this.listQuestionarie = [];
      this.$http
        .get(
          `api/${localStorage.getItem(
            "perfil"
          )}/questionary_location/find_by_stablishment_and_stament_id/${
            JSON.parse(window.localStorage.getItem("user")).location_id
          }/Abierta/${
            JSON.parse(window.localStorage.getItem("user")).stament_id
          }`
        )
        .then(
          (response) => {
            this.listQuestionarie = response.body.questionary;
            console.log(this.listQuestionarie);
            this.loading = false;
          },
          (response) => {
            console.log("error: ", response);
          }
        );
    },
  },
};
</script>

